import { render, staticRenderFns } from "./_errorPage.vue?vue&type=template&id=18e1d176&scoped=true&lang=pug&"
var script = {}
import style0 from "./_errorPage.vue?vue&type=style&index=0&id=18e1d176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1d176",
  null
  
)

export default component.exports